import type { Check } from "./accountChecks";

/**
 * The checks of a form, each marked "OK" or "Fix this" in words, so the meaning never rests on colour. Checks that
 * nothing has been typed for yet are shown as plain hints.
 */
export function CheckList({ checks, started }: { checks: readonly Check[]; started: boolean }) {
  return (
    <ul className="ra-checklist" aria-label="Checks on this form">
      {checks.map((check) => (
        <li key={check.id} data-ok={started ? String(check.ok) : "pending"}>
          <span className="ra-checklist__mark" aria-hidden="true">
            {!started ? "·" : check.ok ? "✓" : "✗"}
          </span>{" "}
          {started && <span className="sr-only">{check.ok ? "OK: " : "Fix this: "}</span>}
          {check.text}
        </li>
      ))}
    </ul>
  );
}
